/*
 * @Author: Yandong Hu
 * @github: https://github.com/Mad-hu
 * @Date: 2022-03-18 09:29:06
 * @LastEditTime: 2022-03-30 10:37:19
 * @LastEditors: Yandong Hu
 * @Description:
 */

import axios from "axios";
// const REACT_APP_BASEURL = process.env.REACT_APP_BASEURL;

const url = window.origin;
const instance = axios.create({
  baseURL: url,
  timeout: 60000,
});
instance.interceptors.response.use(
  (res) => {
    if(res.status === 200) {
      return res.data;
    } else {
      return {};
    }
  },
  (_error) => {
    return Promise.reject(new Error('请求失败，无法连接服务器'));
  });

function post(url: string, params = {}, config = {}) {
  return instance.post(url, params, config);
}
function get(url: string, params = {}, config = {}) {
  return instance.get(url, params);
}
const ajaxService = { post, get };
export default ajaxService;
